import { render, staticRenderFns } from "./VendorSelfRegistration.vue?vue&type=template&id=4d4cc096&"
import script from "./VendorSelfRegistration.vue?vue&type=script&lang=js&"
export * from "./VendorSelfRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VendorSelfRegistration.vue?vue&type=style&index=0&id=4d4cc096&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports